module.exports = __webpack_public_path__ + "img/icon_city8.a7c09dc3.png";